import { SET_LANGUAGE } from '../types/index'

export const setLocale = locales => ( {
  type: SET_LANGUAGE,
  payload: locales
} )


// WEBPACK FOOTER //
// ./src/store/actions/language.js